module.exports = __webpack_public_path__ + "img/studentListEmpty.9e31bd60.png";